// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-Footer-module__footer-VFtZ5 {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  flex-wrap: wrap;
  align-items: center;
}

.nightbot-Footer-module__footerContainer-_0EHs {
  border-top: 1px solid var(--border-primary);
  width: 100%;
  background-color: var(--background-secondary);
}

[data-mantine-color-scheme='light']:root .nightbot-Footer-module__footerContainer-_0EHs {
    border-color: var(--border-secondary);
  }
`, "",{"version":3,"sources":["webpack://./src/components/Footer.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,OAAO;EACP,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,6CAA6C;AAC/C;;AAGE;IACE,qCAAqC;EACvC","sourcesContent":[".footer {\n  width: 100%;\n  flex: 1;\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 24px;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.footerContainer {\n  border-top: 1px solid var(--border-primary);\n  width: 100%;\n  background-color: var(--background-secondary);\n}\n\n@mixin light-root {\n  .footerContainer {\n    border-color: var(--border-secondary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `nightbot-Footer-module__footer-VFtZ5`,
	"footerContainer": `nightbot-Footer-module__footerContainer-_0EHs`
};
export default ___CSS_LOADER_EXPORT___;
